const PAYWALL_ASSET_BASE = "/assets/images/onboarding/paywall";

/** V3 onboarding paywall hero backgrounds (figma_asserts → public/assets). */
export const ONBOARDING_PAYWALL_ASSETS = {
  /** Figma 97034:12776 · UI11 Free trial `96138:32738` */
  freeTrialHero: `${PAYWALL_ASSET_BASE}/paywall-free-trial.webp`,
  /** Figma 97034:12782 · Paywall Free plan offer `96138:32739` */
  freePlanOfferHero: `${PAYWALL_ASSET_BASE}/paywall-freeplan-offer.webp`,
} as const;
